// src/constants/index.jsx

export const APP_CONFIG = {
  name: "Gone Good",
  version: "1.0.0",
  description: "A modern React web application with PWA capabilities",
  author: "Your Name",
  repository: "https://github.com/yourusername/your-repo",
};

export const THEME_CONFIG = {
  STORAGE_KEY: "theme",
  THEMES: {
    LIGHT: "light",
  },
  DEFAULT_THEME: "light",
};

export const BREAKPOINTS = {
  mobile: "768px",
  tablet: "1024px",
  desktop: "1200px",
  wide: "1440px",
};

export const API_CONFIG = {
  BASE_URL: import.meta.env.VITE_API_BASE_URL || "http://localhost:3001",
  TIMEOUT: 10000,
  RETRY_ATTEMPTS: 3,
};

// export const ROUTES = {
//   HOME: "/",
//   ABOUT: "/about",
//   CONTACT: "/contact",
//   PROFILE: "/profile",
//   SETTINGS: "/settings",
//   LOCATION: "/location",
//   STORE_DETAILS: "/store/:storeId",
//   RESERVE_PAY: "/reservepay/:bagId",
//   ORDER_SUMMARY: "/order-summary/:storeId",
//   ORDER_HISTORY: "/order-history",
//   SIGNIN: "/signin",
//   MAGIC_LOGIN: "/magic-login",
// };

export const LOCAL_STORAGE_KEYS = {
  THEME: "app-theme",
  USER_PREFERENCES: "user-preferences",
  LAST_VISIT: "last-visit",
};

export const ANIMATION_DURATION = {
  FAST: 150,
  NORMAL: 300,
  SLOW: 500,
};

export const Z_INDEX = {
  DROPDOWN: 1000,
  STICKY: 1020,
  FIXED: 1030,
  MODAL_BACKDROP: 1040,
  MODAL: 1050,
  POPOVER: 1060,
  TOOLTIP: 1070,
  TOAST: 1080,
};

const backendServiceUrl = "http://localhost:3002/";

const baseUrl = "http://localhost:3000";
const config = {
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": baseUrl,
    "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
  },
  withCredentials: true,
};

export { backendServiceUrl, baseUrl, config };

// Light Theme Color Palette
export const COLORS = {
  // Primary colors
  PRIMARY_BG: "#ffffff",
  SECONDARY_BG: "#f8f9fa",
  TERTIARY_BG: "#f1f3f4",

  // Text colors
  PRIMARY_TEXT: "#212529",
  SECONDARY_TEXT: "#6c757d",
  TERTIARY_TEXT: "#9ca3af",

  // Accent colors
  ACCENT: "#10b981",
  ACCENT_HOVER: "#059669",
  ACCENT_LIGHT: "#d1fae5",

  // Brand colors
  GG_DARK: "#004C42",
  GG_GREEN: "#00CB77",
  GG_PURPLE: "#6F55D3",

  // Status colors
  SUCCESS: "#10b981",
  ERROR: "#ef4444",
  WARNING: "#f59e0b",
  INFO: "#10b981",

  // Border colors
  BORDER: "#dee2e6",
  BORDER_LIGHT: "#f1f3f4",
};

// Responsive breakpoint values
export const SCREEN_SIZES = {
  xs: 480,
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  "2xl": 1536,
};

// Common spacing values
export const SPACING = {
  xs: "0.25rem",
  sm: "0.5rem",
  md: "1rem",
  lg: "1.5rem",
  xl: "2rem",
  "2xl": "3rem",
};

// Typography scales
export const FONT_SIZES = {
  xs: "0.75rem",
  sm: "0.875rem",
  base: "1rem",
  lg: "1.125rem",
  xl: "1.25rem",
  "2xl": "1.5rem",
  "3xl": "1.875rem",
  "4xl": "2.25rem",
};

// Component variants
export const COMPONENT_VARIANTS = {
  BUTTON: {
    PRIMARY: "primary",
    SECONDARY: "secondary",
    OUTLINE: "outline",
    GHOST: "ghost",
  },
  CARD: {
    DEFAULT: "default",
    PRIMARY: "primary",
    ACCENT: "accent",
  },
  TEXT: {
    PRIMARY: "primary",
    SECONDARY: "secondary",
    TERTIARY: "tertiary",
    ACCENT: "accent",
    SUCCESS: "success",
    ERROR: "error",
    WARNING: "warning",
  },
};

export const HUBSPOT_FORMS = {
  "customer-support": "072d33d4-9b78-47c3-ad5c-622b785156ec",
  "customer-registration": "2df61f11-bcd2-4c38-8a98-bd5984878b77",
  "vendor-registration": "e4c4f12f-2702-4a8f-9519-67f3120854e5",
}

export const APP_STORE_LINKS = {
  "apple": "https://apps.apple.com/us/app/gone-good/id6753191342",
  "google": "https://play.google.com/store/apps/details?id=nz.co.gonegood",
}